<div class="basic-app-tab flex flex-col gap-[30px]">
   <mat-tab-group>
      <mat-tab label="Project data">
         <div class="app-tab-basic-content">
            <ep-proposal-detail-tab
               [titleFC]="titleFC"
               [acronymFC]="acronymFC"
               [foundingFC]="foundingFC"
               [durationFC]="durationFC"
               [deadlineFC]="deadlineFC"
               [typeOfActionFC]="typeOfActionFC"
               [typeOfActionArray]="typeOfActionArray"
               [callOfTheProposalFC]="callOfTheProposalFC"
               [generalObjectivesFC]="generalObjectivesFC"
            ></ep-proposal-detail-tab>
         </div>
      </mat-tab>
   </mat-tab-group>

   <div class="flex gap-3 justify-center">
      <p-button
         styleClass="basic-accent-1-button w-[100px] h-[32px] whitespace-nowrap font-semibold"
         label="Save"
         (click)="saveClick()"
      >
      </p-button>
   </div>
</div>
